import IGroup from "interfaces/models/IGroup";
import { GlobalState } from "little-state-machine";

export const updateGroupsFiltered = (state: GlobalState, groupsFilteredUsers: IGroup[]) => ({
  ...state,
  groupsFilteredUsers
});
